import React from 'react';

// Defence-in-depth: mirror backend sanitiser.
function isSafeSVG(svg) {
  if (!svg || typeof svg !== 'string' || !svg.includes('<svg')) return false;
  const lower = svg.toLowerCase();
  const banned = [
    '<script',
    '<foreignobject',
    '<iframe',
    '<style',
    'onload=',
    'onclick=',
    'onerror=',
    'onmouseover=',
    'javascript:',
  ];
  if (banned.some((b) => lower.includes(b))) return false;
  // Must contain a drawing primitive
  const primitives = ['<line', '<rect', '<circle', '<ellipse', '<path', '<polygon', '<polyline', '<text', '<g'];
  return primitives.some((p) => lower.includes(p));
}

// Extract a short accessible title from the SVG, if provided.
function extractTitle(svg) {
  const m = /<title>([^<]{1,120})<\/title>/i.exec(svg || '');
  return m ? m[1].trim() : 'Diagram';
}

export function DiagramBlock({ diagram }) {
  if (!diagram || diagram.type === 'none') return null;

  if (diagram.type === 'svg') {
    if (!isSafeSVG(diagram.svg)) {
      return (
        <div
          className="mt-3 rounded-lg border border-dashed border-neutral-700 bg-neutral-900/60 px-4 py-6 text-center text-xs text-neutral-500"
          data-testid="question-diagram-fallback"
        >
          Diagram unavailable — please read the question carefully.
        </div>
      );
    }
    const title = extractTitle(diagram.svg);
    return (
      <figure
        className="svg-diagram mt-3 flex flex-col items-center gap-1 rounded-lg border border-neutral-800 bg-white p-3 shadow-sm"
        data-testid="question-diagram"
        role="img"
        aria-label={title}
      >
        <div
          className="w-full max-w-md [&>svg]:mx-auto [&>svg]:h-auto [&>svg]:max-w-full"
          dangerouslySetInnerHTML={{ __html: diagram.svg }}
        />
      </figure>
    );
  }

  if (diagram.type === 'image' && diagram.url) {
    return (
      <figure
        className="mt-3 flex justify-center overflow-hidden rounded-lg border border-neutral-800 bg-white p-3"
        data-testid="question-diagram"
      >
        <img
          src={diagram.url}
          alt={diagram.alt || 'Diagram for this question'}
          className="max-h-80 object-contain"
        />
      </figure>
    );
  }

  return null;
}
